import { render, staticRenderFns } from "./ConfigCard.vue?vue&type=template&id=2387076b&scoped=true&"
import script from "./ConfigCard.vue?vue&type=script&lang=js&"
export * from "./ConfigCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCard.vue?vue&type=style&index=0&id=2387076b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387076b",
  null
  
)

export default component.exports